import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
  getAvailableCreditOfCompany,
  getCreditPoolOverview,
  getTotalLocationAvailableCredit,
  getTotalLocationAvailableCreditByCompany,
} from './action';
import { CreditState } from './type';

const initialState: CreditState = {
  availableCreditsOfCompany: null,
  reservedCreditsOfCompany: null,
  negativeCreditFloorLimitOfCompany: null,
  creditsLeftToSpendOfCompany: null,
  totalLocationAvailableCreditOfCompany: null,
  totalLocationAvailableCredit: null,
  creditPoolOverview: null,
};

const { actions, reducer: creditReducer } = createSlice({
  name: 'credit',
  initialState,
  reducers: {
    setAvailableCredits(state, action: PayloadAction<number>) {
      const { payload } = action;
      state.availableCreditsOfCompany = payload;
    },
    setAvailableCreditLocationCompany(state, action: PayloadAction<number>) {
      const { payload } = action;
      state.totalLocationAvailableCreditOfCompany = payload;
    },
    setAvailableCreditLocation(state, action: PayloadAction<number>) {
      const { payload } = action;
      state.totalLocationAvailableCredit = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getAvailableCreditOfCompany.fulfilled,
      (state, action) => {
        const { payload } = action;
        state.availableCreditsOfCompany = payload.availableCredits;
        state.reservedCreditsOfCompany = payload.reservedCredits;
        state.negativeCreditFloorLimitOfCompany = payload.negativeCreditFloorLimit;
        state.creditsLeftToSpendOfCompany = payload.creditsLeftToSpend;
      },
    );
    builder.addCase(getAvailableCreditOfCompany.rejected, (state) => {
      state.availableCreditsOfCompany = null;
      state.reservedCreditsOfCompany = null;
      state.negativeCreditFloorLimitOfCompany = null;
      state.creditsLeftToSpendOfCompany = null;
    });
    builder.addCase(getCreditPoolOverview.fulfilled, (state, action) => {
      state.creditPoolOverview = action.payload;
    });
    builder.addCase(getCreditPoolOverview.rejected, (state) => {
      state.creditPoolOverview = null;
    });
    builder.addCase(
      getTotalLocationAvailableCreditByCompany.fulfilled,
      (state, action: PayloadAction<number>) => {
        state.totalLocationAvailableCreditOfCompany = action.payload;
      },
    );
    builder.addCase(getTotalLocationAvailableCreditByCompany.rejected, (state) => {
      state.totalLocationAvailableCreditOfCompany = null;
    });
    builder.addCase(
      getTotalLocationAvailableCredit.fulfilled,
      (state, action: PayloadAction<number>) => {
        state.totalLocationAvailableCredit = action.payload;
      },
    );
    builder.addCase(getTotalLocationAvailableCredit.rejected, (state) => {
      state.totalLocationAvailableCredit = null;
    });
  },
});

const creditActions = {
  ...actions,
  getAvailableCreditOfCompany,
  getCreditPoolOverview,
  getTotalLocationAvailableCreditByCompany,
  getTotalLocationAvailableCredit,
};

export { creditReducer, creditActions };

export * from './type';
export * from './selector';
